package ui.campaign.detailv2.editor.wrapper

import common.frontend.api.Io
import playlist.ImplPlaylist
import tools.EFieldList
import tools.EFieldRegularBoolean
import tools.EFieldRegularInt
import tools.EFieldRegularTime

class ImplCampaignWrapperEConditionHeader(
    campaign: Io.Campaign,
    var conditions: ImplPlaylist.Conditions
) {
    val pictograms = AdapterWeatherPictograms(conditions, campaign)

    // TIME
    val timeStart = EFieldRegularTime(
        property = conditions.time::start
    )

    val timeEnd = EFieldRegularTime(
        property = conditions.time::end
    )

    // DATE
    val days = EFieldRegularInt(
        property = conditions::days
    )

    // Temperature

    val weatherTemperature = EFieldRegularBoolean(
        property = conditions.weather.temperature::enable
    )

    val weatherTemperatureMin = EFieldRegularInt(
        property = conditions.weather.temperature::min
    )

    val weatherTemperatureMax = EFieldRegularInt(
        property = conditions.weather.temperature::max
    )

    // Wind

    val weatherWind = EFieldRegularBoolean(
        property = conditions.weather.wind::enable
    )

    val weatherWindMin = EFieldRegularInt(
        property = conditions.weather.wind::min
    )

    val weatherWindMax = EFieldRegularInt(
        property = conditions.weather.wind::max
    )

    // Humidity

    val weatherHumidity = EFieldRegularBoolean(
        property = conditions.weather.humidity::enable
    )

    val weatherHumidityMin = EFieldRegularInt(
        property = conditions.weather.humidity::min
    )

    val weatherHumidityMax = EFieldRegularInt(
        property = conditions.weather.humidity::max
    )

    class AdapterWeatherPictograms(
        val conditions: ImplPlaylist.Conditions,
        campaign: Io.Campaign,
        val allPictograms: List<Io.Campaign.WeatherPictograms> = campaign.weatherPictograms
    ) : EFieldList<Long, AdapterWeatherPictograms.Item>(
        items = conditions.weather.pictogram.id,
        onBindEntry = { item ->
            Item(item, allPictograms.firstOrNull { it.id == item }?.name ?: "clearsky_day")
        }
    ) {
        class Item(
            override val data: Long,
            override val key: String
        ) : Entry<Long>
    }
}